module.exports = __webpack_public_path__ + "media/images/city/054-eddystone-lighthouse-d960e7b15d93f91ec59e4179f618342d.svg";